export default __webpack_public_path__ + "static/media/sten1.341084c8.png";